import { LoaderCircle } from 'lucide-react'
import { ILoaderProps } from './types'

export const Loader = (props: ILoaderProps) => {
  return (
    <LoaderCircle
      className="animation-loader"
      size={props.size || 30}
      color={props.color || '#6204E5'}
    />
  )
}
